import { render } from "./AccountRegistrationRoleDetail.vue?vue&type=template&id=7ecfaefa&scoped=true"
import script from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"

import "./AccountRegistrationRoleDetail.vue?vue&type=style&index=0&id=7ecfaefa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecfaefa"]])

export default __exports__